export default __webpack_public_path__ + "static/media/Stats_CDN.07426919.svg";